module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-art-4.ca23f42a.jpg";